export const isMac = () => {
	return navigator.appVersion.indexOf('Mac') !== -1;
};
